import { gsap, ScrollTrigger } from '../utils/gsap-config.js';

export function initScrollAnimations() {
 

} 